module.exports = __webpack_public_path__ + "assets/img/1.37fa3a12.png";